$(function () {
    $('.deelnemernietbekend')
        .on('change', function () {
        	if(this.checked){
				$(this).prev().prop( "disabled", true );
            }else{
				$(this).prev().prop( "disabled", false );
            }
        });        
});